const css = `span.flag {
  width: 44px;
  height: 30px;
  display: inline-block;
}

img.flag {
  width: 30px;
}

.flag {
  background: url(https://primefaces.org/cdn/primereact/images/flag/flags_responsive.png) no-repeat;
  background-size: 100%;
  vertical-align: middle;
}

.flag-ad {
  background-position: 0 0.413223%;
}

.flag-ae {
  background-position: 0 0.826446%;
}

.flag-af {
  background-position: 0 1.239669%;
}

.flag-ag {
  background-position: 0 1.652893%;
}

.flag-ai {
  background-position: 0 2.066116%;
}

.flag-al {
  background-position: 0 2.479339%;
}

.flag-am {
  background-position: 0 2.892562%;
}

.flag-an {
  background-position: 0 3.305785%;
}

.flag-ao {
  background-position: 0 3.719008%;
}

.flag-aq {
  background-position: 0 4.132231%;
}

.flag-ar {
  background-position: 0 4.545455%;
}

.flag-as {
  background-position: 0 4.958678%;
}

.flag-at {
  background-position: 0 5.371901%;
}

.flag-au {
  background-position: 0 5.785124%;
}

.flag-aw {
  background-position: 0 6.198347%;
}

.flag-az {
  background-position: 0 6.61157%;
}

.flag-ba {
  background-position: 0 7.024793%;
}

.flag-bb {
  background-position: 0 7.438017%;
}

.flag-bd {
  background-position: 0 7.85124%;
}

.flag-be {
  background-position: 0 8.264463%;
}

.flag-bf {
  background-position: 0 8.677686%;
}

.flag-bg {
  background-position: 0 9.090909%;
}

.flag-bh {
  background-position: 0 9.504132%;
}

.flag-bi {
  background-position: 0 9.917355%;
}

.flag-bj {
  background-position: 0 10.330579%;
}

.flag-bm {
  background-position: 0 10.743802%;
}

.flag-bn {
  background-position: 0 11.157025%;
}

.flag-bo {
  background-position: 0 11.570248%;
}

.flag-br {
  background-position: 0 11.983471%;
}

.flag-bs {
  background-position: 0 12.396694%;
}

.flag-bt {
  background-position: 0 12.809917%;
}

.flag-bv {
  background-position: 0 13.22314%;
}

.flag-bw {
  background-position: 0 13.636364%;
}

.flag-by {
  background-position: 0 14.049587%;
}

.flag-bz {
  background-position: 0 14.46281%;
}

.flag-ca {
  background-position: 0 14.876033%;
}

.flag-cc {
  background-position: 0 15.289256%;
}

.flag-cd {
  background-position: 0 15.702479%;
}

.flag-cf {
  background-position: 0 16.115702%;
}

.flag-cg {
  background-position: 0 16.528926%;
}

.flag-ch {
  background-position: 0 16.942149%;
}

.flag-ci {
  background-position: 0 17.355372%;
}

.flag-ck {
  background-position: 0 17.768595%;
}

.flag-cl {
  background-position: 0 18.181818%;
}

.flag-cm {
  background-position: 0 18.595041%;
}

.flag-cn {
  background-position: 0 19.008264%;
}

.flag-co {
  background-position: 0 19.421488%;
}

.flag-cr {
  background-position: 0 19.834711%;
}

.flag-cu {
  background-position: 0 20.247934%;
}

.flag-cv {
  background-position: 0 20.661157%;
}

.flag-cx {
  background-position: 0 21.07438%;
}

.flag-cy {
  background-position: 0 21.487603%;
}

.flag-cz {
  background-position: 0 21.900826%;
}

.flag-de {
  background-position: 0 22.31405%;
}

.flag-dj {
  background-position: 0 22.727273%;
}

.flag-dk {
  background-position: 0 23.140496%;
}

.flag-dm {
  background-position: 0 23.553719%;
}

.flag-do {
  background-position: 0 23.966942%;
}

.flag-dz {
  background-position: 0 24.380165%;
}

.flag-ec {
  background-position: 0 24.793388%;
}

.flag-ee {
  background-position: 0 25.206612%;
}

.flag-eg {
  background-position: 0 25.619835%;
}

.flag-eh {
  background-position: 0 26.033058%;
}

.flag-er {
  background-position: 0 26.446281%;
}

.flag-es {
  background-position: 0 26.859504%;
}

.flag-et {
  background-position: 0 27.272727%;
}

.flag-fi {
  background-position: 0 27.68595%;
}

.flag-fj {
  background-position: 0 28.099174%;
}

.flag-fk {
  background-position: 0 28.512397%;
}

.flag-fm {
  background-position: 0 28.92562%;
}

.flag-fo {
  background-position: 0 29.338843%;
}

.flag-fr {
  background-position: 0 29.752066%;
}

.flag-ga {
  background-position: 0 30.165289%;
}

.flag-gd {
  background-position: 0 30.578512%;
}

.flag-ge {
  background-position: 0 30.991736%;
}

.flag-gf {
  background-position: 0 31.404959%;
}

.flag-gh {
  background-position: 0 31.818182%;
}

.flag-gi {
  background-position: 0 32.231405%;
}

.flag-gl {
  background-position: 0 32.644628%;
}

.flag-gm {
  background-position: 0 33.057851%;
}

.flag-gn {
  background-position: 0 33.471074%;
}

.flag-gp {
  background-position: 0 33.884298%;
}

.flag-gq {
  background-position: 0 34.297521%;
}

.flag-gr {
  background-position: 0 34.710744%;
}

.flag-gs {
  background-position: 0 35.123967%;
}

.flag-gt {
  background-position: 0 35.53719%;
}

.flag-gu {
  background-position: 0 35.950413%;
}

.flag-gw {
  background-position: 0 36.363636%;
}

.flag-gy {
  background-position: 0 36.77686%;
}

.flag-hk {
  background-position: 0 37.190083%;
}

.flag-hm {
  background-position: 0 37.603306%;
}

.flag-hn {
  background-position: 0 38.016529%;
}

.flag-hr {
  background-position: 0 38.429752%;
}

.flag-ht {
  background-position: 0 38.842975%;
}

.flag-hu {
  background-position: 0 39.256198%;
}

.flag-id {
  background-position: 0 39.669421%;
}

.flag-ie {
  background-position: 0 40.082645%;
}

.flag-il {
  background-position: 0 40.495868%;
}

.flag-in {
  background-position: 0 40.909091%;
}

.flag-io {
  background-position: 0 41.322314%;
}

.flag-iq {
  background-position: 0 41.735537%;
}

.flag-ir {
  background-position: 0 42.14876%;
}

.flag-is {
  background-position: 0 42.561983%;
}

.flag-it {
  background-position: 0 42.975207%;
}

.flag-jm {
  background-position: 0 43.38843%;
}

.flag-jo {
  background-position: 0 43.801653%;
}

.flag-jp {
  background-position: 0 44.214876%;
}

.flag-ke {
  background-position: 0 44.628099%;
}

.flag-kg {
  background-position: 0 45.041322%;
}

.flag-kh {
  background-position: 0 45.454545%;
}

.flag-ki {
  background-position: 0 45.867769%;
}

.flag-km {
  background-position: 0 46.280992%;
}

.flag-kn {
  background-position: 0 46.694215%;
}

.flag-kp {
  background-position: 0 47.107438%;
}

.flag-kr {
  background-position: 0 47.520661%;
}

.flag-kw {
  background-position: 0 47.933884%;
}

.flag-ky {
  background-position: 0 48.347107%;
}

.flag-kz {
  background-position: 0 48.760331%;
}

.flag-la {
  background-position: 0 49.173554%;
}

.flag-lb {
  background-position: 0 49.586777%;
}

.flag-lc {
  background-position: 0 50%;
}

.flag-li {
  background-position: 0 50.413223%;
}

.flag-lk {
  background-position: 0 50.826446%;
}

.flag-lr {
  background-position: 0 51.239669%;
}

.flag-ls {
  background-position: 0 51.652893%;
}

.flag-lt {
  background-position: 0 52.066116%;
}

.flag-lu {
  background-position: 0 52.479339%;
}

.flag-lv {
  background-position: 0 52.892562%;
}

.flag-ly {
  background-position: 0 53.305785%;
}

.flag-ma {
  background-position: 0 53.719008%;
}

.flag-mc {
  background-position: 0 54.132231%;
}

.flag-md {
  background-position: 0 54.545455%;
}

.flag-me {
  background-position: 0 54.958678%;
}

.flag-mg {
  background-position: 0 55.371901%;
}

.flag-mh {
  background-position: 0 55.785124%;
}

.flag-mk {
  background-position: 0 56.198347%;
}

.flag-ml {
  background-position: 0 56.61157%;
}

.flag-mm {
  background-position: 0 57.024793%;
}

.flag-mn {
  background-position: 0 57.438017%;
}

.flag-mo {
  background-position: 0 57.85124%;
}

.flag-mp {
  background-position: 0 58.264463%;
}

.flag-mq {
  background-position: 0 58.677686%;
}

.flag-mr {
  background-position: 0 59.090909%;
}

.flag-ms {
  background-position: 0 59.504132%;
}

.flag-mt {
  background-position: 0 59.917355%;
}

.flag-mu {
  background-position: 0 60.330579%;
}

.flag-mv {
  background-position: 0 60.743802%;
}

.flag-mw {
  background-position: 0 61.157025%;
}

.flag-mx {
  background-position: 0 61.570248%;
}

.flag-my {
  background-position: 0 61.983471%;
}

.flag-mz {
  background-position: 0 62.396694%;
}

.flag-na {
  background-position: 0 62.809917%;
}

.flag-nc {
  background-position: 0 63.22314%;
}

.flag-ne {
  background-position: 0 63.636364%;
}

.flag-nf {
  background-position: 0 64.049587%;
}

.flag-ng {
  background-position: 0 64.46281%;
}

.flag-ni {
  background-position: 0 64.876033%;
}

.flag-nl {
  background-position: 0 65.289256%;
}

.flag-no {
  background-position: 0 65.702479%;
}

.flag-np {
  background-position: 0 66.115702%;
}

.flag-nr {
  background-position: 0 66.528926%;
}

.flag-nu {
  background-position: 0 66.942149%;
}

.flag-nz {
  background-position: 0 67.355372%;
}

.flag-om {
  background-position: 0 67.768595%;
}

.flag-pa {
  background-position: 0 68.181818%;
}

.flag-pe {
  background-position: 0 68.595041%;
}

.flag-pf {
  background-position: 0 69.008264%;
}

.flag-pg {
  background-position: 0 69.421488%;
}

.flag-ph {
  background-position: 0 69.834711%;
}

.flag-pk {
  background-position: 0 70.247934%;
}

.flag-pl {
  background-position: 0 70.661157%;
}

.flag-pm {
  background-position: 0 71.07438%;
}

.flag-pn {
  background-position: 0 71.487603%;
}

.flag-pr {
  background-position: 0 71.900826%;
}

.flag-pt {
  background-position: 0 72.31405%;
}

.flag-pw {
  background-position: 0 72.727273%;
}

.flag-py {
  background-position: 0 73.140496%;
}

.flag-qa {
  background-position: 0 73.553719%;
}

.flag-re {
  background-position: 0 73.966942%;
}

.flag-ro {
  background-position: 0 74.380165%;
}

.flag-rs {
  background-position: 0 74.793388%;
}

.flag-ru {
  background-position: 0 75.206612%;
}

.flag-rw {
  background-position: 0 75.619835%;
}

.flag-sa {
  background-position: 0 76.033058%;
}

.flag-sb {
  background-position: 0 76.446281%;
}

.flag-sc {
  background-position: 0 76.859504%;
}

.flag-sd {
  background-position: 0 77.272727%;
}

.flag-se {
  background-position: 0 77.68595%;
}

.flag-sg {
  background-position: 0 78.099174%;
}

.flag-sh {
  background-position: 0 78.512397%;
}

.flag-si {
  background-position: 0 78.92562%;
}

.flag-sj {
  background-position: 0 79.338843%;
}

.flag-sk {
  background-position: 0 79.752066%;
}

.flag-sl {
  background-position: 0 80.165289%;
}

.flag-sm {
  background-position: 0 80.578512%;
}

.flag-sn {
  background-position: 0 80.991736%;
}

.flag-so {
  background-position: 0 81.404959%;
}

.flag-sr {
  background-position: 0 81.818182%;
}

.flag-ss {
  background-position: 0 82.231405%;
}

.flag-st {
  background-position: 0 82.644628%;
}

.flag-sv {
  background-position: 0 83.057851%;
}

.flag-sy {
  background-position: 0 83.471074%;
}

.flag-sz {
  background-position: 0 83.884298%;
}

.flag-tc {
  background-position: 0 84.297521%;
}

.flag-td {
  background-position: 0 84.710744%;
}

.flag-tf {
  background-position: 0 85.123967%;
}

.flag-tg {
  background-position: 0 85.53719%;
}

.flag-th {
  background-position: 0 85.950413%;
}

.flag-tj {
  background-position: 0 86.363636%;
}

.flag-tk {
  background-position: 0 86.77686%;
}

.flag-tl {
  background-position: 0 87.190083%;
}

.flag-tm {
  background-position: 0 87.603306%;
}

.flag-tn {
  background-position: 0 88.016529%;
}

.flag-to {
  background-position: 0 88.429752%;
}

.flag-tp {
  background-position: 0 88.842975%;
}

.flag-tr {
  background-position: 0 89.256198%;
}

.flag-tt {
  background-position: 0 89.669421%;
}

.flag-tv {
  background-position: 0 90.082645%;
}

.flag-tw {
  background-position: 0 90.495868%;
}

.flag-ty {
  background-position: 0 90.909091%;
}

.flag-tz {
  background-position: 0 91.322314%;
}

.flag-ua {
  background-position: 0 91.735537%;
}

.flag-ug {
  background-position: 0 92.14876%;
}

.flag-gb, .flag-uk {
  background-position: 0 92.561983%;
}

.flag-um {
  background-position: 0 92.975207%;
}

.flag-us {
  background-position: 0 93.38843%;
}

.flag-uy {
  background-position: 0 93.801653%;
}

.flag-uz {
  background-position: 0 94.214876%;
}

.flag-va {
  background-position: 0 94.628099%;
}

.flag-vc {
  background-position: 0 95.041322%;
}

.flag-ve {
  background-position: 0 95.454545%;
}

.flag-vg {
  background-position: 0 95.867769%;
}

.flag-vi {
  background-position: 0 96.280992%;
}

.flag-vn {
  background-position: 0 96.694215%;
}

.flag-vu {
  background-position: 0 97.107438%;
}

.flag-wf {
  background-position: 0 97.520661%;
}

.flag-ws {
  background-position: 0 97.933884%;
}

.flag-ye {
  background-position: 0 98.347107%;
}

.flag-za {
  background-position: 0 98.760331%;
}

.flag-zm {
  background-position: 0 99.173554%;
}

.flag-zr {
  background-position: 0 99.586777%;
}

.flag-zw {
  background-position: 0 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
